import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CampaignsRoutingModule } from './campaigns-routing.module';
import { ListCampaignsComponent } from './list-campaigns/list-campaigns.component';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditCampaignComponent } from './edit-campaign/edit-campaign.component';
import { PreviewContentComponent } from './preview-content/preview-content.component';
import { EditTemplateComponent } from './edit-template/edit-template.component';
import { CommunicationContentComponent } from './communication-content/communication-content.component';
import { BlockedDatesComponent } from './blocked-dates/blocked-dates.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  NextServiceDateDialogComponent,
} from './list-campaigns/next-service-date-dialog/next-service-date-dialog.component';
import { BlockedDatesV2Component } from './blocked-dates-v2/blocked-dates-v2.component';
import { EditBlockedDateComponent } from './edit-blocked-date/edit-blocked-date.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BlockedDateRulesComponent } from './blocked-date-rules/blocked-date-rules.component';
import { AddBlockedDateRuleComponent } from './add-blocked-date-rule/add-blocked-date-rule.component';

@NgModule({
  declarations: [
    ListCampaignsComponent,
    EditCampaignComponent,
    CommunicationContentComponent,
    PreviewContentComponent,
    EditTemplateComponent,
    BlockedDatesComponent,
    NextServiceDateDialogComponent,
    BlockedDatesV2Component,
    EditBlockedDateComponent,
    BlockedDateRulesComponent,
    AddBlockedDateRuleComponent,
  ],
  imports: [
    CommonModule,
    CampaignsRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    NgxIntlTelInputModule,
  ],
})
export class CampaignsModule {
}